import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { apiFootballFetch, apiFootballStatus } from "./apiFootball.server";

const PathInput = z.object({
  path: z.string().min(1).max(512).regex(/^\/[A-Za-z0-9/?=&,.\-_]+$/),
});

export const apiFootballCall = createServerFn({ method: "POST" })
  .inputValidator((input) => PathInput.parse(input))
  .handler(async ({ data }) => apiFootballFetch(data.path));

export const apiFootballHealth = createServerFn({ method: "GET" })
  .handler(async () => apiFootballStatus());